
export const Rules = {
  menu: {
    app:       "menu:app",
    dashboard: "menu:dashboard",
    settings:  "menu:settings",
    account:   "menu:account",
    company:   "menu:company",
    employee:  "menu:employee",
    inventory: "menu:inventory",
    reports:   "menu:reports",
  },

  page: {
    account: {
      index: "page:account.index"
    },
    company: {
      index: "page:company.index",
      admin: "page:company.admin.index",
      client: "page:company.company.index"
    },
    employee: {
        index: "page:employee.index"
    },
    inventory: {
        index: "page:inventory.inventories.index",
        categories: "page:inventory.categories.index",
        types: "page:inventory.types.index",
        products: "page:inventory.products.index"
    },
    formTypes: {
        index: "page:formTypes.index"
    },
    reports: {
        index: "page:reports.index"
    },
  }
}

export const AdditionalRules = [
  ['access', 'auth:client']
]

const role_administrator = [
    Rules.menu.settings,
    Rules.menu.company,
    Rules.menu.employee,
    Rules.menu.inventory,
    Rules.menu.reports,

    Rules.page.company.index,
    Rules.page.inventory.index,
    Rules.page.inventory.categories,
    Rules.page.inventory.types,
    Rules.page.inventory.products,
    Rules.page.formTypes.index,
    Rules.page.reports.index,
    Rules.page.employee.index,
]

const permissions = {
  all: [
    Rules.menu.app,
    Rules.menu.dashboard,
  ],
  superadmin: [
    ...role_administrator,
    Rules.menu.account,
    Rules.page.account.index,
  ],
  administrator: [
    ...role_administrator
  ],
}

export default permissions
